// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const AssetTypeCodeService = {};

AssetTypeCodeService.getAssetTypeCodeList = function (userInput) {
  return fetch({
    url: "/AssetType/Items?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default AssetTypeCodeService;
